import DateRangePicker from "../../../../components/DateRangePicker.jsx";
import React from "react";
import OrderCentreFilter from "../../../../components/filters/OrderCentreFilter.jsx";
import UpdateDropdown from "../../../../components/dashboard/UpdateDropdown.jsx";
import SourceFilter from "../../../../components/filters/SourceFilter.jsx";
import CampaignFilter from "../../../../components/filters/CampaignFilter.jsx";
import DomainFilter from "../../../../components/filters/DomainFilter.jsx";
import MarketingAndManagerSwitch from "../../../../components/filters/MarketingAndManagerSwitch.jsx";

export default function OrderDashboardFilters({hideFilters, showMarketingFilters = false}) {
    return (
        <div className={'flex-wrap items-center justify-center md:justify-end filter-btn flex gap-1 flex-wrap sm:justify-end pr-4 md:pr-0'}>
            <UpdateDropdown/>
            {showMarketingFilters &&
                <>
                    <MarketingAndManagerSwitch/>
                    <DomainFilter/>
                    <OrderCentreFilter/>
                    <SourceFilter/>
                    <CampaignFilter/>
                </>
            }
            {!hideFilters &&
                <>
                    {!showMarketingFilters && <MarketingAndManagerSwitch/>}
                    {!showMarketingFilters && <DomainFilter/>}
                    {!showMarketingFilters && <OrderCentreFilter/>}
                    <DateRangePicker/>
                </>
            }
        </div>
    );
}
